import Box from '@mui/material/Box';
import { OfflineContent } from '@/components/molecules/OfflineContent/OfflineContent';

export const OfflineOverlay = ({}: OfflineOverlayProps) => {
  return (
    <Box
      sx={{
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100vw',
        height: '100%',
        position: 'fixed',
        zIndex: 9999999999999,
        backgroundColor: '#ffffff',
      }}
    >
      <OfflineContent />
    </Box>
  );
};

interface OfflineOverlayProps {}

OfflineOverlay.displayName = 'OfflineOverlay';

export default OfflineOverlay;
